import { render, staticRenderFns } from "./VerifyPhone.vue?vue&type=template&id=1161a3e5&scoped=true"
import script from "./VerifyPhone.vue?vue&type=script&lang=ts"
export * from "./VerifyPhone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1161a3e5",
  null
  
)

export default component.exports